const WORDS = [
    'Zero','One','Two','Three','Four','Five','Six','Seven','Eight','Nine',
    'Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen',
    'Seventeen','Eighteen','Nineteen','Twenty','Twenty-one','Twenty-two',
    'Twenty-three','Twenty-four','Twenty-five','Twenty-six','Twenty-seven',
    'Twenty-eight','Twenty-nine','Thirty'
];

export function initYearsSince() {
    document.querySelectorAll('[data-years-since]').forEach(el => {
        const start = parseInt(el.dataset.yearsSince, 10);
        const years = new Date().getFullYear() - start;
        el.textContent = WORDS[years] || years;
    });
}
